import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
export function initSentry(user, tenantId) {
    Sentry.init({
        dsn: process.env.SENTRY_DSN,
        release: process.env.VERSION_LONG,
        integrations: [new Integrations.BrowserTracing()],
        environment: process.env.NODE_ENV,
    });
    process.env.BRANCH && Sentry.setTag('branch', process.env.BRANCH);
    process.env.VERSION && Sentry.setTag('version', process.env.VERSION);
    process.env.BUILD_NUMBER && Sentry.setTag('build_number', process.env.BUILD_NUMBER);
    Sentry.setTag('email', user.email);
    Sentry.setTag('keycloak_id', user.keycloakId);
    Sentry.setTag('tentant', tenantId);
}
